// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"_7-z"};